import { BehaviorSubject } from "rxjs";
import api from "src/framework/providers/api";
import { DimensionadoStoreType, PersonalizadoStoreType, VendedorInternoModalStoreType } from "./types";
import { DataGridStore } from "src/framework/store/DataGridStore";

type TabTypes = "list" | "edit" | "new";

export const tab$ = new BehaviorSubject<TabTypes>("list");

export const onConflictAction$ = new BehaviorSubject<(() => void) | null>(null);
export const editRow$ = new BehaviorSubject<any>(null);
export const newRow$ = new BehaviorSubject<any>(null);
export const formState$ = new BehaviorSubject<any>(null);
export const personalizadoStore$ = new BehaviorSubject<PersonalizadoStoreType>({
  tabs: {
    gerador: { done: false, disabled: false },
    estruturas: { done: false, disabled: false },
    acessorios: { done: false, disabled: false },
    finalizacao: { done: false, disabled: false },
  }
});
export const dimensionadoStore$ = new BehaviorSubject<DimensionadoStoreType>({
  roiPaybackModalStatus: { isOpened: false, payload: null },
  drawerIsOpened: false,
  tabs: {
    configuracoes: { done: false, disabled: false },
    inversores: { done: false, disabled: true },
    modulos: { done: false, disabled: true },
    solucao: { done: false, disabled: true },
    valor_total: { done: false, disabled: true }
  }
});

export const alterandoServico$ = new BehaviorSubject<boolean>(false);
export const calculoProjetoRealizado$ = new BehaviorSubject<boolean>(false);
export const exibeJustificativaValorServico$ = new BehaviorSubject<boolean | null>(null);
export const servicoCodeModalIsOpenedStore$ = new BehaviorSubject<boolean>(false);
export const servicoInformationModalIsOpenedStore$ = new BehaviorSubject<boolean>(false);
export const vendedorInternoModalIsOpenedStore$ = new BehaviorSubject<VendedorInternoModalStoreType>({ status: false, onConfirm: () => {} });
export const modalComponentesDetalhesData$ = new BehaviorSubject(0);

export const dataGridStore$ = new BehaviorSubject<DataGridStore>(new DataGridStore(api)) 
